import client from './api-client';

/**
 * Endpoints del tablero "Recupero Directo" (lambda dashboard-directo).
 *
 * Igual que el tablero inter compañía, estas lambdas responden el objeto de datos
 * directo (sin el envoltorio {code, object, message}).
 */
export const getResumenDirecto = async (query) => {
    try {
        const response = await client.post('dashboard-directo/resumen', { query });
        if (response.status === 200) return response.data;
        else throw new Error('No fue posible obtener el resumen del tablero.');
    } catch (error) {
        throw error;
    }
}

export const getMesesDisponiblesDirecto = async () => {
    try {
        const response = await client.post('dashboard-directo/meses-disponibles', {});
        if (response.status === 200) return response.data;
        else throw new Error('No fue posible obtener los meses disponibles.');
    } catch (error) {
        throw error;
    }
}

export const getProveedores = async () => {
    try {
        const response = await client.post('dashboard-directo/proveedores', {});
        if (response.status === 200) return response.data;
        else throw new Error('No fue posible obtener los responsables.');
    } catch (error) {
        throw error;
    }
}

/**
 * RG-602 — Inicia la exportación a Excel de los casos de un indicador (asíncrona).
 * Responde `{ jobId, concepto, cantidad, cantidadWsi }`; con `cantidad: 0` y sin `jobId` no hay nada que
 * exportar. Un volumen excesivo responde 413 con el mensaje "acote el período".
 */
export const exportarCasosDirecto = async (query) => {
    const response = await client.postSinRedireccion('dashboard-directo/exportar', { query });
    if (response.status === 200) return response.data;
    else throw new Error('No fue posible exportar los casos.');
}

/**
 * RG-602 — Estado del trabajo de exportación (se sondea). Responde `{ estado: 'EN_PROCESO' }`,
 * `{ estado: 'ERROR', mensaje }` o `{ estado: 'LISTO', url, filename, cantidad, cantidadWsi }`.
 */
export const estadoExportacionDirecto = async (query) => {
    const response = await client.postSinRedireccion('dashboard-directo/exportar-estado', { query });
    if (response.status === 200) return response.data;
    else throw new Error('No fue posible consultar la exportación.');
}

export const getKpisGlobales = async () => {
    try {
        const response = await client.post('dashboard-directo/kpis-globales', {});
        if (response.status === 200) return response.data;
        else throw new Error('No fue posible obtener los indicadores globales.');
    } catch (error) {
        throw error;
    }
}
